<template>
  <div class="survey-questions__list">
    <div 
      v-for="(question, index) in questions" 
      :key="question.id" 
      :id="question.id"
    >
      <QuestionCard
        :question="question"
        :question-number="startingIndex + index + 1"
        :triggers-selected="hasSelectedTrigger(question)"
        :has-trigger-option="hasAnyTriggerOption(question)"
        @show-image="$emit('show-image', $event)"
        @show-information="$emit('show-information', $event)"
      >
        <!-- Use slots to inject the correct question type content -->
        <div v-if="question.title === 'What is the position of the tooth?'">
          <ToothPositionQuestion 
            :question="question"
            @select-response="$emit('select-response', { question, response: $event })"
            @show-tooth-selector="$emit('show-tooth-selector', question)"
            @show-image="$emit('show-image', $event)"
            @show-information="$emit('show-information', $event)"
          />
        </div>

        <div v-else-if="question.title === 'Root curvature'">
          <RootCurvatureQuestion 
            :question="question"
            @select-response="$emit('select-response', { question, response: $event })"
            @show-measurement-tool="$emit('show-measurement-tool', question)"
            @show-image="$emit('show-image', $event)"
            @show-information="$emit('show-information', $event)"
          />
        </div>

        <div v-else>
          <StandardQuestion 
            :question="question"
            @select-response="$emit('select-response', { question, response: $event })"
            @show-image="$emit('show-image', $event)"
            @show-information="$emit('show-information', $event)"
          />
        </div>
      </QuestionCard>
    </div>
  </div>
</template>

<script>
import QuestionCard from './QuestionCard.vue';
import StandardQuestion from './StandardQuestion.vue';
import ToothPositionQuestion from './ToothPositionQuestion.vue';
import RootCurvatureQuestion from './RootCurvatureQuestion.vue';

export default {
  name: 'QuestionList',
  components: {
    QuestionCard,
    StandardQuestion,
    ToothPositionQuestion,
    RootCurvatureQuestion,
  },
  props: {
    questions: {
      type: Array,
      required: true,
    },
    startingIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    'select-response',
    'show-image',
    'show-information',
    'show-measurement-tool',
    'show-tooth-selector'
  ],
  methods: {
    hasSelectedTrigger(q) {
      const isSelected = Array.isArray(q?.responses) && q.responses.some(
        r => r.isSelected === true && r.loadSystemType != null
      );
      return isSelected;
    },
    hasAnyTriggerOption(q) {
      return Array.isArray(q?.responses) && q.responses.some(
        r => r.loadSystemType != null
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../breakpoints.scss"; 

.survey-questions__list {
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
  margin-bottom: 30px;

  @include md {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
